import { render, staticRenderFns } from "./SaleTaxGroupTaxonomy.vue?vue&type=template&id=0b13c5b6&"
import script from "./SaleTaxGroupTaxonomy.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupTaxonomy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports